import { NgClass } from '@angular/common'
import { Component, effect, inject, input, signal } from '@angular/core'
import { Router } from '@angular/router'

import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { all } from 'iso-3166-1'

import type { OrganizationByIdDto } from '../../../../api/responses/organization'

@Component({
  selector: 'dhp-organization-contact-info',
  templateUrl: './organization-contact-info.component.html',
  styleUrl: './organization-contact-info.component.scss',
  imports: [TranslatePipe, NgClass],
})
export class OrganizationContactInfoComponent {
  private readonly router = inject(Router)
  private readonly translate = inject(TranslateService)
  public readonly organization = input.required<OrganizationByIdDto>()
  public readonly organizationFields = signal<
    [keyof OrganizationByIdDto, string | null | undefined][]
  >([])

  constructor() {
    effect(() => {
      const org = this.organization()
      if (org) {
        const fields: [keyof OrganizationByIdDto, string | null | undefined][] =
          [
            ['name', org.name],
            [
              'streetName',
              [org.streetName, org.streetNumber].filter(Boolean).join(' ') ||
                null,
            ],
            ['postalCode', `${org.postalCode} ${org.city}`],
            [
              'country',
              this.translate.instant('iso3166.' + org.country) ??
                all().find(c => c.alpha2 === org.country)?.country ??
                org.country,
            ],
          ]

        if (org.invoiceAddressee) {
          fields.splice(1, 0, [
            'invoiceAddressee',
            this.translate.instant(
              'components.organizationContactInfo.invoiceAddressee',
              {
                invoiceAddressee: org.invoiceAddressee,
              }
            ),
          ])
        }

        this.organizationFields.set(fields)
      }
    })
  }

  public async editOrganizationInfo(): Promise<void> {
    await this.router.navigate(['/', 'organization'])
  }
}
